import { render, staticRenderFns } from "./SepaPage.vue?vue&type=template&id=8075beba&"
import script from "./SepaPage.vue?vue&type=script&lang=js&"
export * from "./SepaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports